export {
  type ToSignatureHashErrorType as ToEventHashErrorType,
  toSignatureHash as toEventHash,
} from './toSignatureHash.js'
